<template>
  <div class="tweet transition" v-in-viewport.once>
    <div class="tweet__image" v-if="image">
      <img :src="image" class="rs">
    </div>
    <div class="tweet__container">
      <p v-html="text" class="tweet__text"></p>
      <p class="tweet__date">{{ time }}</p>
      <p class="tweet__user">@{{ user }}</p>
      <svg svg-inline="" svg-sprite="" class="tweet__icon" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><use xlink:href="#svg-sprite-408a585b195589a2ad5d52e0c82a968b" href="#svg-sprite-408a585b195589a2ad5d52e0c82a968b"></use></svg>
    </div>
  <svg xmlns="http://www.w3.org/2000/svg" style="display: none !important;"><symbol id="svg-sprite-408a585b195589a2ad5d52e0c82a968b" viewBox="0 0 24 19.5" xmlns="http://www.w3.org/2000/svg"><path d="M24 2.3c-.9.4-1.8.7-2.8.8 1-.6 1.8-1.6 2.2-2.7-1 .6-2 1-3.1 1.2C19.3.6 18 0 16.6 0c-2.7 0-4.9 2.2-4.9 4.9 0 .4 0 .8.1 1.1C7.7 5.8 4.1 3.9 1.6.9c-.4.7-.6 1.6-.6 2.5 0 1.7.9 3.2 2.2 4.1-.8 0-1.6-.2-2.2-.6V7c0 2.4 1.7 4.4 3.9 4.8-.4.1-.8.2-1.3.2-.3 0-.6 0-.9-.1.6 2 2.4 3.4 4.6 3.4-1.7 1.3-3.8 2.1-6.1 2.1-.4 0-.8 0-1.2-.1 2.2 1.4 4.8 2.2 7.6 2.2 9.1 0 14-7.5 14-14v-.6c.9-.7 1.7-1.6 2.4-2.6z" fill="#fff"/></symbol></svg></div>
</template>

<style lang="scss">
.tweet{
  &__container{
    position: relative;
    background-color: #78909c;
    color: white;
    padding: 5rem;
    margin-bottom: 2rem;

    @media #{$bp-sm}{
      padding: 4rem;
    }
  }

  &__image{
    margin-bottom: 2rem;
  }

  &__text{
    color: white;
    font-size: 2.4rem;
    margin-bottom: 2rem;
    @media #{$bp-sm}{
      font-size: 2rem;
    }
    a{
      color: white;
    }
  }

  &__date{
    color: #cbe2f9;
    font-size: 1.4rem;
    margin-bottom: 6rem;
  }

  &__icon{
    position: absolute;
    bottom: 5rem;
    right: 5rem;
    width: 26px;
    height: 22px;

    @media #{$bp-sm}{
      bottom: 4rem;
      right: 4rem;
    }
  }

  &__user{
    font-size: 1.8rem;
  }
}
</style>

<script>
// import TimeAgo from 'javascript-time-ago'
// import fr from 'javascript-time-ago/locale/fr'
// TimeAgo.addLocale(fr)

export default {
  props:[ 'tweet' ],
  data() {
    return {
      isRetweet: false,
      text: '',
      time: '',
      user: '',
      image: false
    };
  },
  methods: {
    
  },
  mounted() {

    if( this.tweet.retweeted_status ){
      this.isRetweet = true
      this.text = twitterLinks(this.tweet.retweeted_status.full_text)
      this.user = this.tweet.retweeted_status.user.screen_name
      if( this.tweet.retweeted_status.entities.media && this.tweet.retweeted_status.entities.media.length > 0 ){
        this.image = this.tweet.retweeted_status.entities.media[0].media_url_https
      }
    }else{
      this.text = twitterLinks(this.tweet.full_text)
      this.user = this.tweet.user.screen_name

      if( this.tweet.entities.media && this.tweet.entities.media.length > 0 ){
        this.image = this.tweet.entities.media[0].media_url_https
      }
    }

    this.time = parseTwitterDate( this.tweet.timestamp )
  },
};

function twitterLinks(text)
{
    var base_url = 'http://twitter.com/';   // identica: 'http://identi.ca/'
    var hashtag_part = 'hashtag/';        // identica: 'tag/'
    // convert URLs into links
    // https://twitter.com/hashtag/TOTAJA

    text = text.replace(
        /(>|<a[^<>]+href=['"])?(https?:\/\/([-a-z0-9]+\.)+[a-z]{2,5}(\/[-a-z0-9!#()\/?&.,]*[^ !#?().,])?)/gi,
        function($0, $1, $2) {
            return ($1 ? $0 : '<a href="' + $2 + '" target="_blank">' + $2 + '</a>');
        });
    // convert protocol-less URLs into links        
    text = text.replace(
        /(:\/\/|>)?\b(([-a-z0-9]+\.)+[a-z]{2,5}(\/[-a-z0-9!#()\/?&.]*[^ !#?().,])?)/gi,
        function($0, $1, $2) {
            return ($1 ? $0 : '<a href="http://' + $2 + '">' + $2 + '</a>');
        });
    // convert @mentions into follow links
    text = text.replace(
        /(:\/\/|>)?(@([_a-z0-9\-]+))/gi,
        function($0, $1, $2, $3) {
            return ($1 ? $0 : '<a href="' + base_url + $3
                + '" title="Follow ' + $3 + '" target="_blank">@' + $3
                + '</a>');
        });
    // convert #hashtags into tag search links
    text = text.replace(
        /(:\/\/[^ <]*|>)?(\#([_a-z0-9éà\-]+))/gi,
        function($0, $1, $2, $3) {
            return ($1 ? $0 : '<a href="' + base_url + hashtag_part + $3
                + '" title="Search tag: ' + $3 + '" target="_blank">#' + $3
                + '</a>');
        });
    return text;
}

function parseTwitterDate(tdate) {
  var systemDate = new Date(tdate*1000);
  var userDate = new Date();

  var diff = Math.floor((userDate - systemDate) / 1000);
  // console.log(diff)
  if (diff <= 1) {return 'just now';}
  if (diff < 20) {return diff + ' seconds ago';}
  if (diff < 40) {return 'half a minute ago';}
  if (diff < 60) {return 'less than a minute ago';}
  if (diff <= 90) {return 'one minute ago';}
  if (diff <= 3540) {return Math.round(diff / 60) + ' minutes ago';}
  if (diff <= 5400) {return '1 hour ago';}
  if (diff <= 86400) {return Math.round(diff / 3600) + ' hours ago';}
  if (diff <= 129600) {return '1 day ago';}
  if (diff < 604800) {return Math.round(diff / 86400) + ' days ago';}
  if (diff <= 777600) {return '1 week ago';}
  return 'on ' + systemDate.getDate() + '/' + systemDate.getMonth() + '/' + systemDate.getFullYear();
}
</script>
